import "react-loading-skeleton/dist/skeleton.css";
import "./App.scss";

import { useTheme } from "@mercdev.com/mercurial-ui/branding";
import Footer from "components/Footer/Footer";
import { useState } from "react";
import { FoldersProvider } from "utils/FoldersContext";

import useFocus from "../../hooks/useFocus";
import CustomDragLayer from "../LinkList/components/CustomDragLayer/CustomDragLayer";
import LinkList from "../LinkList/LinkList";
import { LinksContext } from "../LinkList/useLinksContext";
import ShortenerHeader from "../ShortenerHeader/ShortenerHeader";

const App = () => {
  const [idEditedLink, setIdEditedLink] = useState("");
  const [hasError, setHasError] = useState(false);

  const { inputUrlRef, setInputUrlFocus } = useFocus();
  useTheme();
  return (
    <div className="app">
      <FoldersProvider>
        <LinksContext.Provider
          value={{ idEditedLink, setIdEditedLink, hasError, setHasError }}
        >
          <header className="app__header">
            <ShortenerHeader
              inputUrlRef={inputUrlRef}
              setInputUrlFocus={setInputUrlFocus}
            />
          </header>

          <main className="app__content">
            <LinkList setInputUrlFocus={setInputUrlFocus} />
            <CustomDragLayer />
          </main>

          <Footer />
          <div id="portal-container" />
        </LinksContext.Provider>
      </FoldersProvider>
    </div>
  );
};

export default App;
